import { bff, createBFFHandlers } from '~/framework/bff';
import { z } from 'zod';
import { getServerSideMonolithClient } from '~/framework';
import { CommonRequestOptions } from '~/monolith-api/makeRequest';
import { getUser as getUserFromMonolith } from '~/monolith-api';

export type { User } from '~/monolith-api';

const getUserSchema = z.object({
   userid: z.number(),
});

export async function getUser(userid: number, options: CommonRequestOptions) {
   return await getUserFromMonolith(userid, options);
}

export default createBFFHandlers({
   post: async (req, res) => {
      const { userid } = getUserSchema.parse(req.body);
      const monolithClient = getServerSideMonolithClient(req);
      const result = await getUser(userid, {
         apiClient: monolithClient,
      });
      res.status(200).json(result);
   },
});

export const getUserFromClient = (userid: number): ReturnType<typeof getUser> => {
   return bff()
      .post('/users/getUser', {
         userid,
      })
      .then(response => response.data);
};

export type GetUserErrorCode = 'users.user_not_found';
